<section id="cotizar">
  <div class="main-credit">
    <div class="credit-simulator-container">
      <div class="left-container">

        <div class="title-description-container">
          <div class="title">
            <span>Simula tu crédito</span>
            <span> hoy</span>
          </div>
          <div class="description">
            <span>Tu tasa de interés desde el</span>
            <span> 24% </span>
            <span style="position: relative; left: -5px;">
              *
            </span>
          </div>
        </div>

        <div class="credit-elements">
          <div class="credit-input" style="position: relative;">
            <span>¿Qué monto requieres?</span>
            <img src="{{ icons.inputCurrency }}" alt="" class="input-currency">
            <input currencyMask
              [(ngModel)]="monto"
              [options]="{
                prefix: '$ ',
                thousands: ',',
                decimal: '.',
                allowNegative: false,
                align: 'left',
                min: 0
              }" (ngModelChange)="onMontoChange()">
            <span [style.color]="helperColor">{{ helperText }}</span>
          </div>

          <div class="plazos-container">
            <span>¿Qué plazo prefieres?</span>
            <div class="months-box">
              <div class="coloured-selection"></div>
              <div class="months-option" [ngClass]="{'active': selectedMonth.includes(month)}" (click)="selectMonth(month)" *ngFor="let month of months">
                {{ month }}
              </div>
            </div>
          </div>

          <div class="button-consultar" (click)="consultarCredito()">
            {{ loading ? 'Consultando...' : 'Consultar' }}
          </div>
          <div *ngIf="error" class="error-message">{{ error }}</div>
        </div>

      </div>
      <div class="right-container">
        <div class="credit-resume">
          <div class="credit-resume-text">
            <span>Desde</span>
            <span>
              {{ cotizacion?.payment_per_month ? ('$' + (cotizacion.payment_per_month | number:'1.2-2') + ' mx*') : '$0.00' }}
            </span>
            <span>Mensuales</span>
          </div>
          <button-credito
            [texto]="'Solicitar crédito'"
            [icono]="icons.buttonCircle"
          ></button-credito>
        </div>
        <span class="credit-note">
          *El monto y la tasa exacta de su crédito también dependerá de otros factores como la etapa en la que se encuentre su empresa e historial crediticio.
        </span>
      </div>
    </div>
    <img class="hero-sphere-4" src="{{ icons.sphere1 }}" alt="">
  </div>
</section>
